import bitcrusherUrl from './worklets/bitcrusher-processor.js?url';
import gateUrl from './worklets/gate-processor.js?url';

const loaded = new Set<AudioContext>();

/**
 * Pre-load every AudioWorklet module for a context. Must be awaited before
 * any worklet-based effect is built (the engine does this in ensureContext).
 */
export async function preloadWorklets(ctx: AudioContext): Promise<void> {
  if (loaded.has(ctx)) return;
  await Promise.all([
    ctx.audioWorklet.addModule(bitcrusherUrl),
    ctx.audioWorklet.addModule(gateUrl),
  ]);
  loaded.add(ctx);
}